import { Sparkles } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";
import { HelpMenu } from "@/components/school/HelpMenu";
import { SchoolSays, KindTag } from "@/components/dashboard/CourseWork";

export const SchoolNext = ({ items }) => {
  const { buddy } = useProfile();
  if (!items?.length) return null;
  return (
    <section className="mt-6 rounded-3xl bg-[#EEF3EF] border border-[#CFE0D4] p-6" data-testid="school-next">
      <p className="inline-flex items-center gap-2 text-xs uppercase tracking-widest font-semibold text-[#2C4A3E]"><Sparkles className="w-4 h-4 text-[#C87D53]" />{buddy?.name || "Buddy"} suggests starting with</p>
      <ol className="mt-4 grid md:grid-cols-3 gap-3">
        {items.map((i, n) => (
          <li key={i.id} className="rounded-2xl bg-white border border-[#E6DEC3] p-4 flex flex-col gap-2 bubble-in" style={{ animationDelay: `${n * 0.06}s` }} data-testid={`school-next-${i.id}`}>
            <span className="text-[11px] text-stone-500">{n + 1} · {i.subject_name} · {i.course}</span>
            <p className="font-medium text-[#1F3D33] line-clamp-2">{i.topic} <KindTag i={i} where="next" /></p>
            {!i.manual && <SchoolSays i={i} />}
            <div className="mt-auto pt-1"><HelpMenu i={i} where="next" label="Start with Buddy" /></div>
          </li>
        ))}
      </ol>
      <p className="mt-3 text-xs text-stone-500">Then your ConsciousLearn practice fills in the rest of the day.</p>
    </section>
  );
};
